import { TargetGroupEnum } from "src/_api";

export const TargetGroupEnumTranslations = {
  [TargetGroupEnum.YoungMan]: 'Ung man',
  [TargetGroupEnum.OldMan]: 'Äldre man',
  [TargetGroupEnum.YoungWoman]: 'Ung kvinna',
  [TargetGroupEnum.OldWoman]: 'Äldre kvinna'
};
